/* Questions open and close with an eased height, so the eye can follow. Native <details> stays the fallback:
   no script, reduced motion, or an old browser simply gets the instant open. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(.4, 0, .2, 1)', MS = 340;
  function bind(d) {
    if (d.bsFaq) return; d.bsFaq = true;
    var summary = d.querySelector('summary'), answer = d.querySelector('.bs-faq-a'), anim = null;
    if (!summary || !answer || !answer.animate) return;
    summary.addEventListener('click', function (e) {
      if (reduce || document.hidden) return;
      e.preventDefault();
      var opening = !d.open || d.classList.contains('bs-closing');
      var from = d.open ? answer.getBoundingClientRect().height : 0;       // read before cancelling a run in flight
      if (anim) anim.cancel();
      d.classList.toggle('bs-closing', !opening);
      if (opening) d.open = true;
      var to = opening ? answer.scrollHeight : 0;
      anim = answer.animate(
        [{ height: from + 'px', opacity: opening ? 0 : 1 }, { height: to + 'px', opacity: opening ? 1 : 0 }],
        { duration: MS, easing: EASE });
      anim.onfinish = function () { anim = null; if (!opening) { d.open = false; d.classList.remove('bs-closing'); } };
    });
  }
  function scan(root) { [].forEach.call((root || document).querySelectorAll('[data-bs-faq] details'), bind); }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
